// extracted by mini-css-extract-plugin
export default {"link":"HeadPage_link__8sP5b","lastLink":"HeadPage_lastLink__DCGgg"};